// extracted by mini-css-extract-plugin
module.exports = {"button":"express-checkout-button_button__YdBu2"};